<template>
  <div class="notes-container">
      <el-input
        type="textarea"
        :rows="3"
        v-model="data.value">
      </el-input>
      <el-button @click="saveClicked()" style="margin-top:10px; width:100%" :disabled="data.value == previousValue" type="success" size="mini">{{$l('graphs/markersCat/save')}}</el-button>
  </div>
</template>

<script>
export default {
  props: ['data'],
  data: function(){
    return {
      previousValue: '',
      firstLoad: true,
    }
  },
  methods:{
    saveClicked: function(){
      this.$emit('saveClick');
      this.previousValue = this.data.value;
    }
  },
  mounted: function(){
    //this.previousValue = data.value;
  },
  watch: {
    'data.value': function(value){
      if (this.firstLoad){
        this.firstLoad = false;
        this.previousValue = value;
      }
      if (value != this.previousValue){

      }
    }
  }
}
</script>

<style scoped>
  .notes-container{
      font-family: 'Avenir', Helvetica, Arial, sans-serif;
      -webkit-font-smoothing: antialiased;
      -moz-osx-font-smoothing: grayscale;
      min-width: 350px;
  }
</style>



// WEBPACK FOOTER //
// GraphNotes.vue?80582a3c